import { render, staticRenderFns } from "./AnnotationListElement.vue?vue&type=template&id=5b19d8d1&scoped=true"
import script from "./AnnotationListElement.vue?vue&type=script&lang=ts"
export * from "./AnnotationListElement.vue?vue&type=script&lang=ts"
import style0 from "./AnnotationListElement.vue?vue&type=style&index=0&id=5b19d8d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b19d8d1",
  null
  
)

export default component.exports